import { useEffect } from 'react';

export default function TradeSuccessBanner({ open, message, onClose, durationMs = 2200 }) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const timer = window.setTimeout(() => {
      onClose?.();
    }, durationMs);
    return () => window.clearTimeout(timer);
  }, [open, durationMs, onClose]);

  if (!open || !message) {
    return null;
  }

  return (
    <div className="trade-success-banner" role="status" aria-live="polite">
      {message}
    </div>
  );
}
